import { WithTooltip } from '@infotech/base-components'
import { CRUD_PATH_PLURAL } from './constants'

import { ReactComponent as Moon } from "./moon.svg"

const Icon = WithTooltip({
  placement      : `right`,
  tooltip        : `Внеплановые осмотры`,
  TargetComponent: Moon,
})

export default {
  id  : `expressInspections`,
  name: `Внеплановые осмотры (ночные)`,
  to  : `/${CRUD_PATH_PLURAL}`,
  icon: Icon,
  hide: (capabilities) => !capabilities[`sg.express-inspections.night.access`],
}
